// extracted by mini-css-extract-plugin
export var fadeIn = "_ie-1";
export var modalContent = "_ie-3";
export var overlay = "_ie-0";
export var popoverContent = "_ie-2";
export var results = "_ie-5";
export var searchInputWrapper = "_ie-4";